import { render } from "./WaterRippleBackground.vue?vue&type=template&id=76245c7c&scoped=true"
import script from "./WaterRippleBackground.vue?vue&type=script&lang=js"
export * from "./WaterRippleBackground.vue?vue&type=script&lang=js"

import "./WaterRippleBackground.vue?vue&type=style&index=0&id=76245c7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76245c7c"]])

export default __exports__